const common = {
  site_name: '金沙娱乐',
  site_slogan: '顶级娱乐体验，尽在金沙娱乐',
  nav_home: '首页',
  nav_categories: '游戏分类',
  nav_about: '关于我们',
  nav_register: '立即注册',
  nav_login: '登录',
  footer_copyright: '© 2024 金沙娱乐官方平台 版权所有',
  footer_disclaimer: '金沙娱乐提醒您：适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。',
  breadcrumb_home: '首页',
  back_to_top: '回到顶部',
  read_more: '阅读更多',
  view_all: '查看全部',
  loading: '加载中...',
  no_data: '暂无数据',
  contact_us: '联系我们',
  our_services: '我们的服务',
  quick_links: '快速链接',
  follow_us: '关注我们',
};

export default common;